// A sign-in failure whose message is safe to show the user.
export class SignInError extends Error {
  override readonly name = 'SignInError';
}
